export default __webpack_public_path__ + "static/blogImg-67ff1cfda2cf4a47e6dca968f7bf363d.png";